import React from "react";
import { Mail } from "lucide-react";
import StaticPageLayout from "./StaticPageLayout";

const EMAIL = "contact@arcanechronicles.com";

export default function Contact() {
  return (
    <StaticPageLayout titleIt="Contatti" titleEn="Contact">
      {(isIt) => (
        <>
          <p>
            {isIt
              ? "Per qualsiasi domanda, segnalazione di bug, richiesta di supporto, questione legale o suggerimento, puoi scriverci via email:"
              : "For any question, bug report, support request, legal matter or suggestion, write to us by email:"}
          </p>

          <a
            href={`mailto:${EMAIL}`}
            className="inline-flex items-center gap-2 mt-2 px-4 py-2.5 bg-[#cfb53b]/10 hover:bg-[#cfb53b]/20 border border-[#cfb53b]/50 rounded-md text-[#cfb53b] font-heading transition-colors"
            data-testid="contact-email"
          >
            <Mail size={16} />
            {EMAIL}
          </a>

          <h2 className="font-heading text-xl text-[#cfb53b] mt-6">
            {isIt ? "Tempi di risposta" : "Response times"}
          </h2>
          <p>
            {isIt
              ? "Rispondiamo di norma entro 3-5 giorni lavorativi. Per questioni di privacy / GDPR il tempo massimo previsto dalla legge è 30 giorni."
              : "We usually reply within 3-5 business days. For privacy / GDPR matters the legal maximum is 30 days."}
          </p>

          <h2 className="font-heading text-xl text-[#cfb53b]">
            {isIt ? "Cosa includere" : "What to include"}
          </h2>
          <ul className="list-disc pl-5">
            <li>{isIt ? "Email del tuo account (se pertinente)" : "Your account email (if relevant)"}</li>
            <li>{isIt ? "Descrizione chiara del problema" : "Clear description of the issue"}</li>
            <li>{isIt ? "Screenshot o video se utili" : "Screenshot or video if helpful"}</li>
            <li>{isIt ? "Dispositivo e browser utilizzati" : "Device and browser used"}</li>
          </ul>

          <p className="text-xs text-[#64748b] mt-6">
            {isIt
              ? "Non condividere mai la tua password via email. Il nostro supporto non te la chiederà mai."
              : "Never share your password via email. Our support will never ask for it."}
          </p>
        </>
      )}
    </StaticPageLayout>
  );
}
